var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polygon',{attrs:{"points":"13.5 17 14 0.5 10 0.5 10.5 17 13.5 17"}}),_c('circle',{attrs:{"cx":"12","cy":"21.5","r":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }